import Accordion from "@/common/components/Accordion"
import { CompanyData } from "@/features/companies/types/companies.type"
import { CircleChevronDownIcon, SquareCheckIcon } from "lucide-react"
import { UpdateViewingPoliticsModal } from "../../../Update/components/UpdateViewingPoliticsModal"
import { blockedFlagsMode } from "@/features/privateCompanies/constants/politics/viewingPolitics/blockedFlagsMode.constant"

export const ViewingPoliticsSection = ({ company }: { company: CompanyData | undefined }) => {
  return (
    <Accordion
      defaultOpen
      head={(
        <div className="flex items-center gap-x-3">
          <div onClick={(e) => e.stopPropagation()}>
            <UpdateViewingPoliticsModal company={company} />
          </div>

          <p className='text-xl'>
            Políticas de visualização
          </p>
        </div>
      )}
      triggerClassName="py-0"
      bodyClassName="pt-4 pb-0"
      body={
        <div className='flex flex-col gap-4'>
          <div className='flex items-center gap-3 flex-wrap'>
            <p>
              Bandeiras permitidas:
            </p>

            {Number(company?.allowed_establishment_flags?.length) > 0 ? company?.allowed_establishment_flags?.map(({ establishment_flag }, i) => (
              <div key={`establishment_flag_${i}`} className='flex items-center gap-1 text-white-400'>
                <SquareCheckIcon strokeWidth={1.5} />

                <p className='text-white-800' data-testid="allowed_establishment_flag">
                  {establishment_flag.display_name}
                </p>
              </div>
            )) : (
              <p className='italic font-light' data-testid="allowed_establishment_flags_empty_message">
                Todas
              </p>
            )}
          </div>

          <div className='flex items-center gap-3'>
            <p>
              Demais bandeiras restringir:
            </p>

            <div className='flex items-center gap-1 text-white-400'>
              <CircleChevronDownIcon strokeWidth={1.5} />

              <p className='text-white-800' data-testid="establishment_blocked_flag_mode">
                {company?.establishment_blocked_flags_mode ? blockedFlagsMode[company?.establishment_blocked_flags_mode] : '--'}
              </p>
            </div>
          </div>
        </div>
      }
    />
  )
}

export default ViewingPoliticsSection
